import { Input, Select } from "antd";
import React, { useEffect, useState } from "react";
import { client } from "../../../actions";
import { authHeader } from "../../../helpers/auth-header";
import { dspxGetChildrens } from "../../../helpers/dspx-utils";

const StreetSelect = ({
	street,
	form,
	streets,
	setStreet,
	indexKey,
	loading,
}) => {
	const handleAddrStreetChange = (value) => {
		form.resetFields([`addressIds[${indexKey}]`]);
		setStreet(value);
	};

	return (
		<Select
			loading={loading}
			showSearch
			value={street}
			style={{ width: "50%" }}
			placeholder="Улица"
			notFoundContent="нет данных"
			onChange={handleAddrStreetChange}
			optionLabelProp="label"
			optionFilterProp="searchtext"
		>
			{dspxGetChildrens(streets)}
		</Select>
	);
};

const HouseSelect = ({ house, houses, setHouse, form, indexKey }) => {
	const handleAddrBuildingChange = (value) => {
		form.resetFields([`addressIds[${indexKey}]`]);
		setHouse(value);
	};

	return (
		<Select
			showSearch
			value={house}
			style={{ width: "25%" }}
			notFoundContent="нет данных"
			placeholder="Дом"
			optionFilterProp="searchtext"
			onChange={handleAddrBuildingChange}
		>
			{dspxGetChildrens(houses)}
		</Select>
	);
};

const FlatSelect = ({ flats, ...rest }) => {
	return (
		<>
			<Select
				{...rest}
				showSearch
				notFoundContent="нет данных"
				style={{ width: "25%" }}
				placeholder="Кв./офис"
				optionFilterProp="searchtext"
			>
				{dspxGetChildrens(flats)}
			</Select>
		</>
	);
};

const NewDocumentsAddressField = ({
	form,
	indexKey,
	contractorType,
	allowDelete,
	...rest
}) => {
	const [streets, setStreets] = useState();
	const [loadingStreets, setLoadingStreets] = useState();
	const [street, setStreet] = useState();
	const [houses, setHouses] = useState();
	const [house, setHouse] = useState();
	const [flats, setFlats] = useState();

	useEffect(() => {
		(async () => {
			let rurl = "/Request/streets";
			setLoadingStreets(true);
			const response = await client.get(rurl, { headers: authHeader() });
			setLoadingStreets(false);
			setStreets(response.data);
		})();
	}, []);

	useEffect(() => {
		(async () => {
			let rurl = "/Request/houses";
			if (street && !isNaN(street)) {
				rurl += "/" + street;
				const response = await client.get(rurl, { headers: authHeader() });
				setHouses(response.data);
			}
		})();
	}, [street]);

	useEffect(() => {
		(async () => {
			let rurl = "/Request/house_flats";
			if (house && !isNaN(house)) {
				rurl += "/" + house;
				const response = await client.get(rurl, { headers: authHeader() });
				setFlats(response.data);
			}
		})();
	}, [house]);

	const commonProps = {
		indexKey,
		form,
	};

	return (
		<Input.Group
			compact
			style={{ width: allowDelete ? "95%" : "100%", marginBottom: 10 }}
			key={`addressIds${indexKey}`}
		>
			<StreetSelect
				loading={loadingStreets}
				{...commonProps}
				streets={streets}
				street={street}
				setStreet={setStreet}
				setHouses={setHouses}
			/>
			<HouseSelect
				{...commonProps}
				house={house}
				setHouse={setHouse}
				houses={houses}
				setFlats={setFlats}
			/>
			<FlatSelect
				{...rest}
				{...commonProps}
				contractorType={contractorType}
				form={form}
				flats={flats}
			/>
		</Input.Group>
	);
};

export default NewDocumentsAddressField;
